var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.classes},[_c('div',{class:_vm.containedClasses},[(_vm.partialItem.name)?_c('NuxtContent',{staticClass:"content",attrs:{"document":_vm.partialItem}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }